export default __webpack_public_path__ + "assets/92a98e469e7c8263935f6f143c3a0a90-business_card_foil.png";